import { assert } from 'assert-ts';
import { InfoCircle } from '#assets/ReactSvg.ts';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';

/**
 * When there are no admin identity providers configured
 */
export function EmptyAdminIdentityProvider() {
  const userType = useAuth().user?.type;

  assert(userType === 'user', `Expected userType to be "user", got ${userType}`);

  return (
    <>
      <Banner variant="info" Icon={InfoCircle} className="mb-24">
        No provider configured for admins.{' '}
        <Link className="a" to="/settings/sso/add">
          Add provider
        </Link>
      </Banner>
      <ul className="ul-md">
        <li className="p">
          OpenID Connect identity providers allow other employees at your organization to access this admin panel.
        </li>
        <li className="p">
          Additional admins will have the same access that you do, but will not be able to see or change these identity
          provider settings.
        </li>
      </ul>
    </>
  );
}
